
import VueCropper from "vue-cropperjs"
import "cropperjs/dist/cropper.min.css"

export default {
  components: { VueCropper },

  props: {
    initialImg: { type: Object, default: null },
    aspectRatio: { type: Number, default: 1 },
    previewHeight: { type: String, default: "16rem" },
    maxWidth: { type: Number, default: 512 },
    maxHeight: { type: Number, default: 512 },
  },

  data () {
    return {
      img: this.initialImg,
      previewSrc: "",
      error: "",
      isLoading: false,
    }
  },

  watch: {
    img (img) {
      if (img?.file) {
        this.previewSrc = ""
        this.$refs.cropper?.replace(img.file)
      }
    },
  },

  methods: {
    rotate (deg) {
      this.$refs.cropper?.rotate(deg)
    },

    async crop () {
      const { cropper } = this.$refs
      if (!cropper) return
      const canvas = cropper.getCroppedCanvas({
        maxWidth: this.maxWidth, maxHeight: this.maxHeight,
      })
      if (!canvas) return
      this.isLoading = true
      const blob = await new Promise(resolve => canvas.toBlob(resolve))

      const [res, err] = await this.$api.upload
        .uploadTmpFile(blob, this.img.name)
      if (!err) {
        this.previewSrc = res?.url || ""
        this.$emit("change", res?.id || undefined)
        // this.img = null
      } else {
        this.error = err
        this.img = null
        this.$emit("change", undefined)
      }
      this.isLoading = false
    },
  },
}
